import { createFileRoute } from '@tanstack/react-router';
import { ManualSegmentTabRoute } from './-route-wrappers';

/**
 * A manual segment's Overview tab at its own URL. No `appBundle`: this URL has no `journeys` segment
 * for the resolver to rebuild a target from. The resolver runs inside the flag branch, in
 * `ManualSegmentTabRoute`.
 */
function SegmentOverviewTabRoute() {
  const { segmentId } = Route.useParams();

  return <ManualSegmentTabRoute segmentId={segmentId} tab="overview" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/segments/$segmentId/overview')({
  component: SegmentOverviewTabRoute,
});
